module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/ForgedinFire.823ae59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/ForgedinFire.jpg
// module id = LJ3M
// module chunks = 0